<template>
  <div>
    <div class="row">
      <div class="col-10">
        <PurchasingSummaryWidget :filter="filter" :gridHeight="250" />
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="250">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/purchasing/purchasingreports#tab-report-stock-usage">Stock Usage / Incoming Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/purchasing/purchasingreports#tab-report-purchasing">Stock Purchasing Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/purchasing/purchasingreports#tab-report-container-purchasing">Container Purchasing</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/purchasing/purchasingreports#tab-report-supplier-performance">Supplier Performance Report</AnalyticsReportLink>
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <PurchasingIncomingStockWidget :filter="filter" :gridHeight="500" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <PurchasingSupplierPerformanceChartWidget :filter="filter" :gridHeight="550" />
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import PurchasingSummaryWidget from '@/modules/intelligence/dashboardWidgets/purchasingSummaryWidget'
import PurchasingIncomingStockWidget from '@/modules/intelligence/dashboardWidgets/purchasingIncomingStockWidget'
import PurchasingSupplierPerformanceChartWidget from '@/modules/intelligence/dashboardWidgets/purchasingSupplierPerformanceChartWidget'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsPurchasingDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,
    ReportFilterPopover,
    ReportDateRangeSelect,
    PurchasingSummaryWidget,
    PurchasingIncomingStockWidget,
    PurchasingSupplierPerformanceChartWidget
  },
  props: {
    filter: Object
  },
  data() {
    return {
      
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  methods: {
    
  }
  
}
</script>